import BaseRating from "../../sisu/form/BaseRating.sisu"

const NeoRating = (props) => {
  return <BaseRating {...props} />
}

export default NeoRating